import { c as _c } from "react/compiler-runtime";
import React from "react";
import CustomTooltip from "./CustomTooltip";
import UserProfileTooltip from "@/components/user/utils/profile/UserProfileTooltip";
import useDeviceInfo from "@/hooks/useDeviceInfo";
interface UserProfileTooltipWrapperProps {
  readonly user: string;
  readonly children: React.ReactElement;
  readonly placement?: "top" | "bottom" | "left" | "right" | "auto" | undefined;
}
export default function UserProfileTooltipWrapper(t0) {
  const $ = _c(8);
  const {
    user,
    children,
    placement: t1
  } = t0;
  const placement = t1 === undefined ? "auto" : t1;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  if (hasTouchScreen) {
    let t2;
    if ($[0] !== children) {
      t2 = <>{children}</>;
      $[0] = children;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== user) {
    t2 = <UserProfileTooltip user={user} />;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== placement || $[6] !== t2) {
    t3 = <CustomTooltip content={t2} placement={placement} delayShow={500} delayHide={0}>{children}</CustomTooltip>;
    $[4] = children;
    $[5] = placement;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}